import _last from 'lodash/last'

const truncateStringForUI = (input: string, length: number): string =>
  input.length > length
    ? `${input.substring(0, length)}..${_last(input)}`
    : input

export default truncateStringForUI
